import { render, staticRenderFns } from "./system_mechanism_management.vue?vue&type=template&id=8fd07c5a&scoped=true&"
import script from "./system_mechanism_management.vue?vue&type=script&lang=js&"
export * from "./system_mechanism_management.vue?vue&type=script&lang=js&"
import style0 from "./system_mechanism_management.vue?vue&type=style&index=0&id=8fd07c5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd07c5a",
  null
  
)

export default component.exports